import { NgClass } from "@angular/common";
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Inject,
  OnDestroy,
  Output,
  Renderer2,
  signal,
  ViewChild, OnInit,
} from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { doc, docData, Firestore, getDoc } from "@angular/fire/firestore";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatButton } from "@angular/material/button";
import { MatDialogActions } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { Data, Router } from "@angular/router";
import { Browser } from "@capacitor/browser";
import { Share } from "@capacitor/share";
import { AuthService } from "@core/auth.service";
import { AuthSyndicateService } from "@core/AuthServices/authSyndicate/auth-syndicate.service";
import { UserVersionService } from "@core/AuthServices/authUserVersion/auth-user-version.service";
import { LoadingService } from "@core/loading.service";
import {
  buildPushToastPayload,
  readLanguageCodeFromStorage,
  resolvePushToastLanguage,
} from "@core/push-notification-toast.i18n";
import { UtilityService } from "@core/utility.service";
import { defaultLanguage } from "@interfaces/translation-interface";
import { VoucherClaimResult } from "@interfaces/vouchers.i";
import { IonicModule, MenuController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import * as _ from "lodash";
import { EMPTY, from, Observable, of, Subject, Subscription, throwError } from "rxjs";
import { catchError, map, switchMap, take, takeUntil } from "rxjs/operators";
import { CommonVariable } from "src/app/app.constants";
import { AccountRepositoryService } from "src/app/pages/account/account-repository.service";
import { StoreRepositoryService } from "src/app/pages/store/store-repository.service";
import { CommonService } from "src/app/services/common/common.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { MarketingCampaignsService } from "src/app/services/marketing-campaigns.service";
import { MixpanelService } from "src/app/services/mixpanel.service";
import { OneSignalService } from "src/app/services/one-signal.service";
import { RequestProfileService } from "src/app/services/RequestBodyService/RequestProfile/request-profile.service";
import { TrackedEventsService } from "src/app/services/tracked-events.service";
import { VoucherService } from "src/app/services/vouchers.service";
import { environment } from "src/environments/environment.prod";
import { SafeHtmlPipe } from "../../pipe/safehtmlpipe";
@Component({
  selector: "app-inbox-message",
  templateUrl: "./inbox-message.component.html",
  styleUrls: ["./inbox-message.component.scss"],
  standalone: true,
  imports: [
    MatDialogActions,
    MatButton,
    NgClass,
    IonicModule,
    SafeHtmlPipe,
  ],
})
export class InboxMessageComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild("dynamicContent") dynamicContent: ElementRef;
  @HostBinding("class.tyviso-host") get tyvisoHostClass(): boolean {
    return this.tyvisoMsg;
  }
  @Output() InboxDelete = new EventEmitter();
  selectedLanguage: string = "en";
  referral_code: string = "";
  referralUrl: string = "";
  dynamicScriptsExecuted: boolean;
  private claimCreditListenerCleanup: () => void;
  private urlToEasterPlunko = "/games/instant-win-game/533";
  private urlToCoinDozer = "/games/instant-win-game/592";
  private urlToRfSection = "/mainTabs/tabs/game#rapid-fire";
  private urlToInstantWinSection = "/mainTabs/tabs/game#instant-win";
  private urlToPrizeSection = "/mainTabs/tabs/game#prize";
  private urlToChristmasPlunko = "/games/instant-win-game/605";
  private urlToValentinesPlunko = "/games/instant-win-game/627";
  private urlToPaymentHoliday = "/mainTabs/tabs/syndicate/payment-holiday";
  private defaultErrorText = "Something went wrong, please try again";
  private urlToPartialPage = "/partial-registration?prosub_id=2473&TP1=pwa_inbox";
  private defaultErrorTextInt = {
    de: "Etwas ist schief gelaufen. Bitte versuche es erneut",
    en: "Something went wrong, please try again",
    es: "Algo salió mal. Por favor, vuelva a intentarlo",
    fr: "Une erreur s'est produite. Veuillez réessayer",
    it: "Qualcosa è andato storto, prova ancora",
  };
  private languageSubsciption: Subscription;
  private redeemVoucherSubscription: Subscription;

  private urlToHome = "/mainTabs/tabs/home";
  private urlToPartnerOfferPage = "/partner-offer";
  public plunkoWimbeldonStatus = false;
  public plunkoChristmasStatus = false;
  public plunkoValentinesStatus = false;
  public plunkoEasterStatus = false;
  public versionMessage = false;
  public promotionMsg = false;
  private regexForGameDetailsRedirect =
    /\/games\/(skill-game|instant-win-game|game-blog|replayable|adventure-game|rapid-fire-game)(\/.*)?/;

  private jackpotsData: Data[];
  public data: Data;
  private jackpotValueKey = "[jackpot_value=";
  private jackpotNextDrawDateKey = "[count_nearest_draw_date=";
  private jackpotEndPromotionKey = "[count_end_of_promotion=";
  private sumJackpotKey = "[sum_jackpot=";
  private jackpotSubscription: Subscription;
  private preferredCurrency = "GBP";
  private currencySymbol = "£";
  private isInboxJackpotMessage = false;
  public mustWinTemplate = false;
  public inboxChurnRisk = false;
  public tyvisoMsg = false;
  public tyvisoOffers: Data[] = [];
  private tyvisoExpandedTerms = new Set<string>();
  private tyvisoSheetEl: HTMLElement | null = null;
  private tyvisoViewportCleanup: (() => void) | null = null;
  private endOfPromotionKey = "[count_end_of_promotion=";
  private flashSaleExpiryKey = "[flash_sale_expiry]";
  private endOfPromotionPattern = /\[count_end_of_promotion=([^[\]]+)]/;
  public newSjPrizeStatus = false;
  private urlToNewPrizeLoose = "/store/products/EuroMillions?payment=3507";
  private euroMillionsYellowExtractString = "euromillions yellow";
  private domainName = "lottosocial.com";
  public defaultLanguage: string;
  public checkListMsg = false;
  private unsubscribe$ = new Subject<void>();
  selectedLanguageSignal = signal<string>("")
  preferredCurrencySignal = signal<string>("")
  userId: string;
  constructor(
    private firestore: Firestore,
    private oneSignalService: OneSignalService,
    private sheet: MatBottomSheet,
    private analytics: AngularFireAnalytics,
    @Inject(MAT_BOTTOM_SHEET_DATA) public inboxData: any,
    private matBottomSheet: MatBottomSheetRef<InboxMessageComponent>,
    private authService: AuthService,
    private menu: MenuController,
    private router: Router,
    private GTMSegment: GTMSegmentService,
    public translate: TranslateService,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private voucherService: VoucherService,
    private loadingService: LoadingService,
    private storeService: StoreRepositoryService,
    private renderer: Renderer2,
    private RequestProfileService: RequestProfileService,
    private AuthSyndicateService: AuthSyndicateService,
    private UserVersionService: UserVersionService,
    private accountService: AccountRepositoryService,
    private trackedEventsService: TrackedEventsService,
    private mixpanelService: MixpanelService,
    private marketingCampaignsService: MarketingCampaignsService,
    private commonService: CommonService,

  ) {
    this.authService
      ?.getUid("InboxMessageComponent - constructor")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    this.dynamicScriptsExecuted = false;
    this.defaultLanguage = defaultLanguage;
    this.data = _.cloneDeep(this.inboxData);
    if (this.data?.template_type === 'wmp_end_we_won' || this.data?.template_type === 'wmp_end_user_won') {
      const timer = this.data?.auto_show ? 1100 : 0;
      setTimeout(() => {
        this.executeDynamicScripts();
      }, timer);
    }
    this.generateReferralShortUrl();
    this.languageSubsciption = this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguageSignal.set(l ? l : "en")
        this.selectedLanguage = this.selectedLanguageSignal();
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
    this.fetchLatestOngoingSyndicate();
    this.GTMSegment?.GTMPopupInitialization("InboxMessage");
    if (this.data.auto_show) {
      this.inboxMessageViewed();
    }
    const limbId = this.data?.limb_id === this.data?.id ? this.data?.limb_id : this.data?.id;
    if (this.data.template_type && this.data.template_type === "plunko_wimbeldon") {
      this.plunkoWimbeldonStatus = true;
    } else {
      this.plunkoWimbeldonStatus = false;
    }
    if (this.data && this.data?.template_type === "plunko_christmas") {
      this.plunkoChristmasStatus = true;
    } else {
      this.plunkoChristmasStatus = false;
    }
    if (this.data?.template_type && this.data.template_type === "rapidfire_mustwin") {
      this.mustWinTemplate = true;
    }
    if (this.data?.template_name === "version_update_message") {
      this.versionMessage = true;
    } else {
      this.versionMessage = false;
    }
    if (this.data?.template_type === "valentine_plunko_campaign") {
      this.plunkoValentinesStatus = true;
    } else {
      this.plunkoValentinesStatus = false;
    }
    if (this.data.extract === "Checklist completed") {
      this.checkListMsg = true;
    } else {
      this.checkListMsg = false;
    }
    if (this.data.template_name === "inbox_churn_risk") {
      this.inboxChurnRisk = true;
    }
    if (this.data?.template_name === "inbox_partner_offer") {
      this.promotionMsg = true;
    } else {
      this.promotionMsg = false;
    }
    if (String(this.data?.template_name || "").toLowerCase() === "tyviso") {
      this.tyvisoMsg = true;
      const offers = this.data?.template_data?.offers;
      this.tyvisoOffers = Array.isArray(offers)
        ? offers.filter((offer: Data) => !!offer?.url)
        : [];
      this.tyvisoExpandedTerms.clear();
    } else {
      this.tyvisoMsg = false;
      this.tyvisoOffers = [];
      this.tyvisoExpandedTerms.clear();
    }
    this.plunkoEasterStatus = this.data?.template_type === "easter_plunko_campaign";
    const templateTypes = ["new_sj_prize_draw_confirm", "new_sj_prize_draw_loss", "new_sj_prize_draw_win"];
    this.newSjPrizeStatus = templateTypes.includes(this.data.template_name);
    try {
      if (this.data?.message_content?.indexOf("Icon") >= 0) {
        this.data["icon"] = this.data?.message_content?.substring(this.data?.message_content?.indexOf("Icon") + 5);
      }
      const inboxUpdate = this.data?.view_count + 1;
      const inboxViewed = inboxUpdate >= this.data?.view_capping;
      if (this.data?.view_count >= this.data?.view_capping || this.data?.dismissed == true || inboxViewed) {
        this.InboxDelete.emit();
        this.GTMSegment?.GTMPopupInitialization("InboxDelete");

        const path_id = "dQ2JLcXGOr5fbVp8gyIf";
        const doc_data = { hide: true };
        const dv = { docId: limbId };
        const method = "update";

        this.authService.getV2CloudFunction("updatefirestoredoc", {
          path_id,
          doc_data,
          dv,
          method,
        }).subscribe({
          error: (error) => {
            return error;
          }
        });
      }
    } catch (e) {
      return e;
    }

    this.analytics.logEvent("inbox_messages", { userId: this.userId });
    const userId = this.userId;
    const docRef = doc(this.firestore, `/users/${userId}/inbox/${limbId}`);

    const path_id = "dQ2JLcXGOr5fbVp8gyIf";
    const doc_data = {
      auto_show: false,
      viewed: true,
      view_count: this.data?.view_count + 1
    };
    const dv = { docId: limbId };
    const method = "update";

    this.authService.getV2CloudFunction("updatefirestoredoc", {
      path_id,
      doc_data,
      dv,
      method,
    }).subscribe({
      error: (error) => {
        return error;
      }
    });

    if (
      this.data?.message_content?.includes(this.jackpotValueKey) ||
      this.data?.message_content?.includes(this.jackpotNextDrawDateKey) ||
      this.data?.message_content?.includes(this.sumJackpotKey)
    ) {
      this.isInboxJackpotMessage = true;
      this.authService?.userDetails$?.pipe(
        switchMap((user: Data) => {
          this.preferredCurrencySignal.set(user?.preferred_currency ?? CommonVariable.preferredCurrency);
          this.preferredCurrency = this.preferredCurrencySignal();
          return this.authService.getCurrencyList$;
        }),
        takeUntil(this.unsubscribe$)
      ).subscribe((data: Data) => {
        const CurrencyDetails = data?.details?.find(
          (x: Data) => x?.currency_code === this.preferredCurrencySignal()
        );
        this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
        this.fetchJackpotData();
      });
    } else if (
      (this.data?.template_type === "plunko_christmas" ||
        this.data?.template_type === "valentine_plunko_campaign" ||
        this.data?.template_type === "easter_plunko_campaign") &&
      this.data?.message_content?.includes(this.jackpotEndPromotionKey)
    ) {
      this.countEndOfPromotion();
    } else if (this.data?.message_content?.includes(this.endOfPromotionKey)) {
      this.countEndOfPromotion();
    } else if (this.data?.message_content.includes(this.flashSaleExpiryKey)) {
      this.checkForFlashSaleExpiryDate();
    }
  }

  async ngOnInit(): Promise<void> {
    await this.authService
      ?.getUid("InboxMessageComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
  }

  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  async close() {
    await this.sheet.dismiss();
    await this.menu.open("inboxMenu").catch((err) => { });
  }

  // method to safely navigate to EuroMillions page
  private navigateToEuroMillions() {
    this.authService.ensureValidAuth().subscribe(isAuthenticated => {
      if (isAuthenticated) {
        this.router.navigateByUrl(this.urlToNewPrizeLoose);
      } else {
        // Handle unauthenticated case
        this.authService.getConstantsMsg("1026")
          .then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Unable to access page. Please try again.",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          })
          .catch((error) => {
            return error;
          });
      }
    });
  }

  navigateTo(link: string) {
    this.sheet.dismiss();
    if (link && this.urlToPaymentHoliday.search(link) > -1) {
      this.router.navigateByUrl(this.urlToPaymentHoliday);
    }
  }

  public generateReferralShortUrl() {
    // This method is used to retrieve user details for the database.
    this.authService.userDetails$.pipe(take(1)).subscribe({
      next: (data: Data) => {
        this.referral_code = data?.referral_code;
        if (data?.referral_url && this.data?.added_function?.content?.gc) {
          this.referralUrl = data.referral_url + "?gc=" + this.data.added_function.content.gc;
        } else {
          this.getReferralURL();
        }
      },
      error: (error) => {
        return error;
      },
    });
  }

  getReferralURL(): void {
    this.accountService
      .getShortReferralUrl(this.referral_code, "", this.data?.added_function?.content?.gc ?? "")
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: string) => {
        try {
          this.referralUrl = res;
        } catch (error) {
          return throwError(error);
        }
      });
  }

  openUrl(link: string) {
    this.sheet.dismiss();
    this.checkForFreePlay();
    if (link === "pushrequest") {
      this.activateNotification();
    } else {
      const match = link?.match(this.regexForGameDetailsRedirect);
      if (match) {
        const pathToGamesDetails = match[0];
        this.router.navigateByUrl(pathToGamesDetails);
      } else if (link && this.urlToHome.search(link) > -1) {
        this.router.navigateByUrl(this.urlToHome);
      } else if (link && link.search("tip=discount_voucher_store") > -1) {
        this.router.navigateByUrl(link);
      } else if (link && link.search("typeform") > -1) {
        this.marketingCampaignsService.triggerTypeForm(link);
      } else if (link && link?.search(this.urlToPartnerOfferPage) > -1) {
        const path = link?.split("/");
        if (path && path?.length > 0) {
          this.router.navigateByUrl(path[path.length - 1]);
        }
      } else if (link && link.search(this.urlToChristmasPlunko) > -1) {
        this.router.navigateByUrl(this.urlToChristmasPlunko);
      } else if (link && link.search(this.urlToValentinesPlunko) > -1) {
        this.router.navigateByUrl(this.urlToValentinesPlunko);
      } else if (link && link.search(this.urlToNewPrizeLoose) > -1) {
        this.navigateToEuroMillions();
      } else if (link && link.search(this.urlToEasterPlunko) > -1) {
        this.router.navigateByUrl(this.urlToEasterPlunko);
      } else if (link && link.search(this.urlToCoinDozer) > -1) {
        this.router.navigateByUrl(this.urlToCoinDozer);
      } else if (link && link.search("#rapid-fire") > -1) {
        this.router.navigateByUrl(this.urlToRfSection);
      } else if (link && link.search("#instant-win") > -1) {
        this.router.navigateByUrl(this.urlToInstantWinSection);
      } else if (link && link.search("#prize") > -1) {
        this.router.navigateByUrl(this.urlToPrizeSection);
      } else if (link && link.search("game") > -1) {
        this.router.navigate([decodeURIComponent(link)]);
      } else if (link && link.search("payment") > -1) {
        this.router.navigateByUrl(`${decodeURIComponent(link)}`);
      } else if (link && link.search("store") > -1) {
        this.router.navigateByUrl("/mainTabs/tabs/store");
      } else if (link && link.search(this.urlToPartialPage)) {
        this.router.navigateByUrl(link);
      } else if (link && link.search("offer") > -1) {
        const productName = link?.split("?")[1];
        this.router.navigateByUrl("/store/products/" + productName?.split("&")[0].trim());
      } else if (link && link != "") {
        this.router.navigateByUrl(`${decodeURIComponent(link)}`);
      }
    }

    if (this.data?.added_function?.function_name == "webshare" && !this.data?.destination) {
      this.invite();
    }
  }

  openTyvisoOffer(url: string) {
    if (!url) {
      return;
    }
    if (/^https?:\/\//i.test(url)) {
      Browser.open({ url }).catch(() => {
        window.open(url, "_blank");
      });
      return;
    }
    this.openUrl(url);
  }

  hasTyvisoTerms(offer: Data): boolean {
    return typeof offer?.terms === "string" && offer.terms.trim().length > 0;
  }

  isTyvisoTermsExpanded(offer: Data, index: number): boolean {
    return this.tyvisoExpandedTerms.has(this.tyvisoTermsKey(offer, index));
  }

  tyvisoTermsPanelId(offer: Data, index: number): string {
    return `tyviso-terms-panel-${this.tyvisoTermsKey(offer, index)}`;
  }

  toggleTyvisoTerms(offer: Data, index: number, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    if (!this.hasTyvisoTerms(offer)) {
      return;
    }
    const key = this.tyvisoTermsKey(offer, index);
    if (this.tyvisoExpandedTerms.has(key)) {
      this.tyvisoExpandedTerms.delete(key);
    } else {
      this.tyvisoExpandedTerms.add(key);
    }
  }

  private tyvisoTermsKey(offer: Data, index: number): string {
    return String(offer?.id || offer?.url || index);
  }

  onTyvisoImageError(event: Event) {
    const image = event?.target as HTMLImageElement | null;
    if (!image) {
      return;
    }
    image.classList.add("tyviso-image-hidden");
    const badge = image.closest(".tyviso-logo-badge");
    if (badge) {
      badge.classList.add("tyviso-image-hidden");
    }
  }

  invite() {
    const userId = this.userId;
    const docRef = doc(this.firestore, `/users/${userId}/in_app_notification/status`);

    this.commonService.getUid("invite").pipe(
      take(1),
      switchMap((userId) => {
        if (!userId) {
          return EMPTY;
        }
        const docRef = doc(this.firestore, `/users/${userId}/in_app_notification/status`);
        return from(getDoc(docRef)).pipe(
          switchMap((snapshot) => {
            const inAppNotificationData = snapshot.data();

            if (inAppNotificationData?.out_of_points_promotion) {

              return this.authService.getV2CloudFunction("updatefirestoredoc", {
                path_id: "dQ2JLcXGOr5fbVp8gyIf",
                doc_data: {
                  auto_show: false,
                  viewed: true,
                  view_count: this.data.view_count + 1,
                },
                dv: { docId: this.data.id },
                method: "update",
              }).pipe(
                catchError((error) => {
                  return of(error);
                })
              );
            } else {
              return this.authService.getV2CloudFunction("updatefirestoredoc", {
                path_id: "KdpTQsnyjKvgqvjItVvT",
                doc_data: {
                  referred_friend: {
                    status: true,
                    updatedOn: new Date(),
                  },
                },
                method: "update",
              }).pipe(
                catchError((error) => {
                  return of(error);
                })
              );
            }
          })
        );
      })
    ).subscribe();
    // Update promo_details in Firestore
    const path_id = "1cblQl68QltRugb1YDAY";
    const method = "read";

    this.authService?.getV2CloudFunction("updatefirestoredoc", {
      path_id,
      method,
    }).pipe(
      map((snapshot: any) => snapshot?.data)
    ).subscribe({
      next: (docSnap: any) => {
        if (docSnap) {
          const promoDetails = docSnap?.promo_details || [];
          const updatedPromoDetails = promoDetails.map(promo => promo.promo_name === "refer_friend" ? { ...promo, status: true } : promo);
          this.authService.getV2CloudFunction("updatefirestoredoc", {
            path_id: "1cblQl68QltRugb1YDAY",
            doc_data: { promo_details: updatedPromoDetails },
            method: "update",
          }).pipe(catchError((error) => of(error))).subscribe();
        }
      },
      error: () => {
        // handle error
      }
    });
    // ✅ Track MGM Link
    const body = { MGM_Link: this.referralUrl || null };
    this.GTMSegment?.trackEvent("MGM Link Shared", body);

    let isUpdatedCelebration = false;
    this.inviteViaSocialsharing();

    this.trackedEventsService?.listOfEvents$?.pipe(takeUntil(this.unsubscribe$))?.subscribe({
      next: (response) => {
        if (!Array.isArray(response)) {
          return;
        }
        const webShareAPI = "web_share_API";
        response.some((f) => f.id === webShareAPI)
          ? this.trackedEventsService.updateTrackedUserEvent(webShareAPI)
          : null;

        response.map((data: Data) => {
          if (data.id === webShareAPI && !isUpdatedCelebration) {
            this.trackedEventsService.updateCelebration(data);
            isUpdatedCelebration = true;
          }
        }, (err) => {
          return err;
        });
      },
      error: (err) => {
        return err;
      },
    });

    setTimeout(() => {
      this.trackedEventsService.openAnimation();
    }, 2000);
  }

  async inviteViaSocialsharing() {
    try {
      await Share.share({
        title: this.data?.added_function?.content?.title,
        text: this.data?.added_function?.content?.text,
        url: this.referralUrl,
      }).catch(() => {
        this.showErrorMessage();
      });
      this.friendSocialButtonsMixpanel("invite");
    } catch (error) {
      this.showErrorMessage();
    }
  }

  showErrorMessage() {
    this.authService
      .getConstantsMsg("1015")
      .then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "something went wrong!",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      })
      .catch((error) => {
        return error;
      });
  }

  public friendSocialButtonsMixpanel(txtRefer: string) {
    this.mixpanelService.init(this.userId);

    this.mixpanelService.track("MGM Link Shared", {
      current_url: window.location.href,
      share_method: txtRefer,
    });
  }

  checkForFreePlay() {
    try {
      if (this.data?.issue?.assign_free_play) {
        this.RequestProfileService.inboxMessageHideRequest(this.data, this.data?.issue?.reason)
          .pipe(
            switchMap((payload) => {
              return this.authService.getV2CloudFunction("apisyncv2", payload);
            })
          )
          .subscribe({
            next: (res) => {
              if (res?.status?.includes("success")) {
                this.hideInboxMessage();
              }
            },
            error: () => {
              // handle error
            },
          });
      }
    } catch (error) {
      return error;
    }
  }


  hideInboxMessage() {
    const limbId = this.data?.limb_id === this.data?.id ? this.data?.limb_id : this.data?.id;
    this.GTMSegment?.GTMPopupInitialization("InboxDelete");
    const path_id = "dQ2JLcXGOr5fbVp8gyIf";
    const doc_data = { hide: true };
    const dv = { docId: limbId };
    const method = "update";

    this.authService.getV2CloudFunction("updatefirestoredoc", {
      path_id,
      doc_data,
      dv,
      method,
    }).subscribe({
      error: (error) => {
        return error;
      }
    });
  }

  ngAfterViewInit() {
    this.lockTyvisoSheetScroll();
    let voucherBtnEl = this.elementRef.nativeElement.querySelector("#voucher-button");
    if (voucherBtnEl) {
      voucherBtnEl.addEventListener("click", () => {
        try {
          const voucherCode = voucherBtnEl?.getAttribute("voucherID");
          this.redeemVoucher(voucherCode, false);
        } catch (error) {
          return error;
        }
      });
    }

    if (this.data.template_name === "new_sj_prize_draw_confirm" && this.dynamicContent?.nativeElement) {
      const anchorElement = this.dynamicContent.nativeElement.querySelector(".play_btn");
      if (anchorElement) {
        this.renderer.listen(anchorElement, "click", () => {
          this.prizeDrawPlayButton();
        });
      }
    }

    if (this.data.template_name === "new_sj_prize_draw_loss") {
      const anchorTag = this.elementRef.nativeElement.querySelector(".play_btn");
      if (anchorTag) {
        // Add a click event listener to the anchor tag
        this.renderer.listen(anchorTag, "click", (event: Event) => {
          event.preventDefault();
          this.redirectToAnchorTagUrl();
        });
      }
    }

    if (this.isInboxJackpotMessage) {
      const containerEl = this.elementRef.nativeElement.querySelector(".container");
      this.renderer.setStyle(containerEl, "margin-bottom", "0");
    }

    if (this.data?.extract?.toLowerCase()?.includes(this.euroMillionsYellowExtractString)) {
      const anchorTag = this.elementRef.nativeElement.querySelector(".play_btn");
      if (anchorTag) {
        // Add a click event listener to the anchor tag
        this.renderer.listen(anchorTag, "click", (event: Event) => {
          event.preventDefault();
          this.redirectToAnchorTagUrl();
        });
      }
    }

    // Dynamically execute scripts for specific post cache out inbox templates
    // In your method:
    if (this.dynamicContent?.nativeElement) {
      const button = this.dynamicContent.nativeElement.querySelector('.claim_credit');
      this.commonService.getUid("").pipe(takeUntil(this.unsubscribe$)).subscribe({
        next: (res) => {
          if (button && !this.claimCreditListenerCleanup) {
            this.claimCreditListenerCleanup = this.renderer.listen(button, 'click', () => {
              this.sheet.dismiss();
              const typedFormsUrl = `${environment.postCacheTypedFormsURL}#uid=${res}`;
              location.assign(typedFormsUrl);
            });
          }

        }
      })
    }
  }

  redeemVoucher(voucherCode: string, claimFromList, voucherId?) {
    this.sheet.dismiss();
    if (!window.navigator.onLine) return;
    this.loadingService.present();
    try {
      this.redeemVoucherSubscription = this.voucherService
        .redeemVoucher(voucherCode, "/api_post_request/validate_voucher", "")
        ?.subscribe(
          (voucherResponse: VoucherClaimResult) => {
            if (voucherResponse?.status === "rejected" || voucherResponse?.status === "FAIL") {
              this.authService
                ?.getConstantsMsg(voucherResponse?.error_code)
                .then((translatedMsg) => {
                  this.showToaster(translatedMsg, voucherResponse?.message);
                  this.loadingService.dismiss();
                })
                .catch((error) => {
                  return error;
                });
              return;
            }
            if (voucherResponse.status?.toLowerCase() === "success") {
              this.voucherService?.voucherRedeemed(voucherId);
              if (voucherResponse?.mobile_app_award_type == "offer") {
                this.voucherService.setSyndicatePending();
              }
              this.voucherService.onVoucherSuccessClaim(voucherResponse);
            } else {
              if (voucherId) {
                this.voucherService?.voucherRedeemed(voucherId);
              }
              if (voucherResponse.message?.toLowerCase().search("no longer") && voucherId) {
                this.voucherService.hideInvalidVoucher(voucherId);
              }
            }
            this.loadingService.dismiss();
          },
          (error) => {
            this.loadingService.dismiss();
            this.showToaster(this.defaultErrorTextInt[this.selectedLanguageSignal()], this.defaultErrorText);
            return error;
          }
        );
    } catch (err) {
      this.loadingService.dismiss();
      this.showToaster(this.defaultErrorTextInt[this.selectedLanguageSignal()], this.defaultErrorText);
      return err;
    }
  }

  showToaster(translatedMsg: string, initialMsg: string) {
    const defaultMsg = {
      message: {
        line_1: initialMsg,
        line_2: "",
      },
      style: {
        icon: "tick circle error.svg",
        type: "Error",
      },
    };
    this.authService.showToastMessage(translatedMsg, defaultMsg);
  }

  fetchJackpotData() {
    this.jackpotSubscription = this.storeService.storePageData$.subscribe((data) => {
      if (!data) return;
      this.jackpotsData = data;
      this.checkForJackpotProduct();
      this.checkForJackpotDrawDate();
      this.checkForSumJackpot();
    });
  }

  private checkForJackpotProduct() {
    const regex = /\[jackpot_value=([^[\]]*)]/;
    const match = this.data?.message_content.match(regex);

    if (match) {
      const product = this.jackpotsData.find((p) => p?.real_name?.toLowerCase() === match[1]);

      if (product && product?.jackpot?.jackpot_value) {
        const jackpotRegex = /\[jackpot_value=[^\]]*]/;
        const productIntValue = this.getIntJackpotData(product);
        this.data.message_content = this.data?.message_content.replace(
          jackpotRegex,
          this.currencySymbol + productIntValue + "🔥"
        );
      }
    }
  }

  getGlobalChristmasPlunkoExpiry() {
    const docRef = doc(this.firestore, '/Global_lookup/template_messages/inbox/inbox_plunko_christmas');
    return docData(docRef).pipe(
      map(data => data ?? null) // returns document data or null if none
    );
  }

  private endOfPromotionDate() {
    this.getGlobalChristmasPlunkoExpiry().subscribe(
      (res) => {
        const regex = /\[count_end_of_promotion=([^[\]]*)]/;
        const match = this.data?.message_content.match(regex);

        if (match) {
          const drawDateRegex = /\[count_end_of_promotion=[^\]]*]/;

          const expiryDateSeconds = res?.expiry_date?.seconds;
          if (!expiryDateSeconds) {
            return;
          }
          const expiryDate = expiryDateSeconds * 1000;
          const now = new Date().getTime();
          const timeDifference = expiryDate - now;

          let nextDrawString = "";

          if (timeDifference <= 0) {
            nextDrawString = "expired";
          } else {
            nextDrawString = this.formatTime(timeDifference);
            this.data.message_content = this.data?.message_content.replace(drawDateRegex, nextDrawString);
          }
        }
      },
      (error) => {
        return error;
      }
    );
  }

  private checkForJackpotDrawDate() {
    const regex = /\[count_nearest_draw_date=([^[\]]*)]/;
    const match = this.data?.message_content.match(regex);

    if (match) {
      const product = this.jackpotsData.find((p) => p?.real_name?.toLowerCase() === match[1].toLowerCase());

      if (product) {
        const drawDateRegex = /\[count_nearest_draw_date=[^\]]*]/;

        const expiryDateSeconds = product?.jackpot?.expiry_date?.seconds;
        if (!expiryDateSeconds) {
          return;
        }
        const expiryDate = expiryDateSeconds * 1000;
        const now = new Date().getTime();
        const timeDifference = expiryDate - now;

        let nextDrawString = "";

        if (timeDifference <= 0) {
          nextDrawString = "expired";
        } else {
          nextDrawString = this.formatTime(timeDifference);
          this.data.message_content = this.data?.message_content.replace(drawDateRegex, nextDrawString);
        }
      }
    }
  }

  private checkForFlashSaleExpiryDate() {
    // Check if the message content contains the placeholder "[flash_sale_expiry]"
    const placeholder = this.flashSaleExpiryKey;
    if (this.data?.message_content.includes(placeholder)) {
      // Get the expiry date from `this.data.expiry_date`
      const expiryDate = this.data?.expiry_date?.seconds * 1000; // Convert seconds to milliseconds
      const now = new Date().getTime();
      const timeDifference = expiryDate - now;

      let expiryString = "";

      // Check if the expiry time has passed
      if (timeDifference <= 0) {
        expiryString = "expired";
      } else {
        expiryString = this.formatTime(timeDifference); // Format the remaining time
      }

      // Replace the placeholder with the expiry string
      this.data.message_content = this.data.message_content.replace(placeholder, expiryString);
    }
  }


  checkForSumJackpot() {
    const regex = /\[sum_jackpot=([^[\]]*)]/;
    const match = this.data?.message_content.match(regex);
    if (match) {
      const productNames = match[1]?.split(",");
      const sumJackpot = this.calculateSumJackpot(productNames);
      const formattedSum = this.convertJackpotNumberToString(sumJackpot);
      this.data.message_content = this.data?.message_content.replace(
        match[0],
        this.currencySymbol + formattedSum + "🔥"
      );
    }
  }

  calculateSumJackpot(productNames: string[]): number {
    let sum = 0;
    for (const productName of productNames) {
      const product = this.jackpotsData.find((p) => p?.real_name?.toLowerCase() === productName.toLowerCase());
      if (product && product?.jackpot?.jackpot_value) {
        const productIntValue = this.getIntJackpotData(product);
        const jackpotValue = this.convertJackpotStringToNumber(productIntValue);
        sum += jackpotValue ?? 0;
      }
    }
    return sum;
  }

  convertJackpotStringToNumber(jackpotString: string): number {
    const value = parseFloat(jackpotString);
    if (jackpotString?.toLowerCase()?.endsWith("k")) {
      return value * 1000;
    } else if (jackpotString?.toLowerCase()?.endsWith("m")) {
      return value * 1000000;
    } else {
      return value;
    }
  }

  convertJackpotNumberToString(jackpotNumber: number): string {
    if (jackpotNumber >= 1000000000) {
      return (jackpotNumber / 1000000000)?.toFixed(0) + "B";
    } else if (jackpotNumber >= 1000000) {
      return (jackpotNumber / 1000000)?.toFixed(0) + "M";
    } else if (jackpotNumber >= 1000) {
      return (jackpotNumber / 1000)?.toFixed(0) + "K";
    } else {
      return jackpotNumber?.toFixed(0);
    }
  }

  private formatTime(ms: number): string {
    const seconds = Math.floor((ms / 1000) % 60);
    const minutes = Math.floor((ms / (1000 * 60)) % 60);
    const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
    const days = Math.floor(ms / (1000 * 60 * 60 * 24));

    if (days > 0) {
      return `${days}d ${hours}hrs ${minutes}m`;
    } else {
      let formattedTime = "";

      if (hours > 0) {
        formattedTime += `${hours}hrs `;
      }
      if (minutes > 0) {
        formattedTime += `${minutes}m `;
      }
      if (seconds > 0) {
        formattedTime += `${seconds}s`;
      }

      return formattedTime.trim();
    }
  }

  getIntJackpotData(product) {
    return product?.jackpot?.int_jackpot_value?.[this.preferredCurrency]
      ? product?.jackpot?.int_jackpot_value?.[this.preferredCurrency]
      : product?.jackpot?.jackpot_value;
  }

  ngOnDestroy(): void {
    this.unlockTyvisoSheetScroll();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.languageSubsciption?.unsubscribe();
    this.jackpotSubscription?.unsubscribe();
    this.redeemVoucherSubscription?.unsubscribe();
    if (this.claimCreditListenerCleanup) {
      this.claimCreditListenerCleanup();
      this.claimCreditListenerCleanup = null;
    }
  }

  private lockTyvisoSheetScroll(): void {
    if (!this.tyvisoMsg) {
      return;
    }
    const sheet = this.elementRef.nativeElement.closest(
      ".mat-bottom-sheet-container"
    ) as HTMLElement | null;
    if (!sheet) {
      return;
    }
    this.tyvisoSheetEl = sheet;
    this.renderer.setStyle(sheet, "overflow", "hidden");
    this.renderer.setStyle(sheet, "display", "flex");
    this.renderer.setStyle(sheet, "flex-direction", "column");
    this.syncTyvisoViewportHeight();

    const viewport = window.visualViewport;
    if (viewport) {
      const onViewportChange = () => this.syncTyvisoViewportHeight();
      viewport.addEventListener("resize", onViewportChange);
      viewport.addEventListener("scroll", onViewportChange);
      this.tyvisoViewportCleanup = () => {
        viewport.removeEventListener("resize", onViewportChange);
        viewport.removeEventListener("scroll", onViewportChange);
      };
    }
  }

  private syncTyvisoViewportHeight(): void {
    const height = Math.floor(window.visualViewport?.height || window.innerHeight || 0);
    if (!height) {
      return;
    }
    const heightPx = `${height}px`;
    if (this.tyvisoSheetEl) {
      this.renderer.setStyle(this.tyvisoSheetEl, "height", heightPx);
      this.renderer.setStyle(this.tyvisoSheetEl, "max-height", heightPx);
      this.renderer.setStyle(this.tyvisoSheetEl, "min-height", "0");
    }
    this.renderer.setStyle(this.elementRef.nativeElement, "height", heightPx);
    this.renderer.setStyle(this.elementRef.nativeElement, "max-height", heightPx);
  }

  private unlockTyvisoSheetScroll(): void {
    if (this.tyvisoViewportCleanup) {
      this.tyvisoViewportCleanup();
      this.tyvisoViewportCleanup = null;
    }
    if (this.tyvisoSheetEl) {
      this.renderer.removeStyle(this.tyvisoSheetEl, "overflow");
      this.renderer.removeStyle(this.tyvisoSheetEl, "display");
      this.renderer.removeStyle(this.tyvisoSheetEl, "flex-direction");
      this.renderer.removeStyle(this.tyvisoSheetEl, "height");
      this.renderer.removeStyle(this.tyvisoSheetEl, "max-height");
      this.renderer.removeStyle(this.tyvisoSheetEl, "min-height");
      this.tyvisoSheetEl = null;
    }
    this.renderer.removeStyle(this.elementRef.nativeElement, "height");
    this.renderer.removeStyle(this.elementRef.nativeElement, "max-height");
  }

  async closeDialog() {
    await this.matBottomSheet.dismiss();
    await this.close();
  }


  private countEndOfPromotion(): void {
    const endOfPromotionMatch = this.data?.message_content.match(this.endOfPromotionPattern);
    if (endOfPromotionMatch && endOfPromotionMatch.length > 1) {
      const matchedTemplate = endOfPromotionMatch[1];
      this.getGlobalTemplateData(matchedTemplate).subscribe(
        (res: Data) => {
          if (res) {
            const regex = /\[count_end_of_promotion=([^[\]]*)]/;
            const match = this.data?.message_content.match(regex);

            if (match) {
              const drawDateRegex = /\[count_end_of_promotion=[^\]]*]/;

              const expiryDateSeconds = res?.expiry_date?.seconds;
              if (!expiryDateSeconds) {
                return;
              }
              const expiryDate = expiryDateSeconds * 1000;
              const now = new Date().getTime();
              const timeDifference = expiryDate - now;

              let nextDrawString = "";

              if (timeDifference <= 0) {
                nextDrawString = "expired";
              } else {
                nextDrawString = this.formatTime(timeDifference);
                this.data.message_content = this.data?.message_content.replace(drawDateRegex, nextDrawString);
              }
            }
          }
        },
        (err) => {
          return err;
        }
      );
    }
  }

  /**
   * The `prizeDrawPlayButton` function navigates to a destination, closes a menu, and dismisses a bottom
   * sheet and a sheet.
   */
  async prizeDrawPlayButton() {
    try {
      if (this.data?.destination) {
        this.router.navigateByUrl(this.data?.destination);
        await this.menu.close("inboxMenu").catch((err) => {
          return err;
        });
      }
      this.matBottomSheet.dismiss();
      this.sheet.dismiss();
    } catch (error) {
      return error;
    }
  }

  private getGlobalTemplateData(templateType: string): Observable<Data | null> {
    const docRef = doc(this.firestore, `/Global_lookup/template_messages/inbox/${templateType}`);
    return docData(docRef).pipe(
      map(data => data ?? null)  // returns the document data or null if not found
    );
  }

  private redirectToAnchorTagUrl(): void {
    // Retrieve the dynamic URL from the href attribute
    const anchorTag = this.elementRef.nativeElement.querySelector(".play_btn");
    const registrationUrl = anchorTag?.href;
    const finalUrl = registrationUrl?.split(this.domainName)[1];
    this.matBottomSheet.dismiss();
    // Navigate to the URL using Angular's Router
    this.router.navigateByUrl(finalUrl);
  }

  // This function is used to get latest ongoing syndicates
  async fetchLatestOngoingSyndicate() {
    try {
      const latestSyndicate = await this.authService.getLatestOngoingSyndicate();
      this.authService.latestOngoingSyndicate$.next(latestSyndicate);
    } catch (error) {
      return error;
    }
  }
  public activateNotification() {
    try {
      if (!UtilityService.isAppInstalledOnHomePage() && CommonVariable.device.operatingSystem === "ios") {
        this.UserVersionService?.showOnesignalIosToast();
        return;
      }
      const userID = this.userId;
      if (userID !== null && userID !== undefined) {
        // calling push notification service
        this.oneSignalService.optIn(userID).subscribe({
          error: (error) => {
            console.error("Error while activating push notification from inbox message", error);
          },
        });
      } else {
        const lang = resolvePushToastLanguage(
          this.authService?.selectedlanguage$?.value,
          readLanguageCodeFromStorage()
        );
        const defaultMsg = buildPushToastPayload("something_went_wrong", lang, {
          duration: 2000,
          icon: "tick circle error.svg",
          type: "Error",
        });
        this.authService?.showToastMessage(null, defaultMsg);
        throw new Error("userID is null or undefined");
      }
    } catch (err) {
      return err;
    }
  }
  // This method is used tto trigger Inbox Message Viewed Events
  inboxMessageViewed() {
    const message = this.data;
    let startTime = new Date();
    if (this.userId == "null" || this.userId == null) return;
    let endTime = new Date();
    let dwellTime = endTime.getTime() - startTime.getTime();
    let formattedDwellTime = this.AuthSyndicateService.convertMillisecondsToTime(dwellTime);
    const body = { Opt_Msg_ID: message?.limb_id || message?.id, Message_Title: message?.extract, Message_Template_Name: message?.template_name || null, Dwell_Time: formattedDwellTime, CTA_Text: message?.button_label || null, Destination_URL: message?.destination || null, Inbox_Message_Type: message?.auto_show || null, Autoshow: message?.auto_show ? message?.auto_show_inbox_page || null : null };

    this.GTMSegment.GTMPopupInitializationForInboxNew("Inbox Message Viewed", body);
  }
  //  This method is used to calculate scroll depth
  calculateSectionScrollDepth() {
    const sectionElement = this.elementRef?.nativeElement?.querySelector('#targetSection');
    if (sectionElement) {
      const sectionHeight = sectionElement?.offsetHeight;
      const sectionTop = sectionElement?.getBoundingClientRect()?.top;
      const windowHeight = window?.innerHeight;

      // Calculate scroll depth relative to the section
      if (sectionTop >= 0 && sectionTop <= windowHeight) {
        const visibleHeight = Math.min(sectionHeight, windowHeight - sectionTop);
        return (visibleHeight / sectionHeight) * 100;
      } else {
        return 0;
      }
    }
  }
  private executeDynamicScripts() {
    try {
      if (this.dynamicScriptsExecuted || !this.dynamicContent?.nativeElement) {
        return;
      }
      this.dynamicScriptsExecuted = true;

      const scripts = this.dynamicContent.nativeElement.querySelectorAll('script');
      scripts.forEach((script: HTMLScriptElement) => {
        try {
          // Wrap script content in a try-catch to isolate errors from individual scripts
          const wrappedContent = `
            (function() { 
              try {
                ${script.textContent}
              } catch (err) {
                console.error('[Dynamic Script Error]', err);
              }
            })();
          `;
          const newScript = document.createElement('script');
          newScript.textContent = wrappedContent;
          document.body.appendChild(newScript);
          document.body.removeChild(newScript); // Clean up after execution
        } catch {
              // Continue to next script even if this one fails
        }
      });
    } catch {
      //Handle error
    }
  }
}
